module.exports = {"520327001":"龙泉街道","520327002":"何坝街道","520327003":"花坪街道","520327004":"凤岭街道","520327101":"进化镇","520327102":"琊川镇","520327103":"蜂岩镇","520327104":"永和镇","520327106":"绥阳镇","520327107":"土溪镇","520327108":"永安镇","520327110":"天桥镇","520327111":"王寨镇","520327112":"新建镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520327.json
// module id = 2604
// module chunks = 0